import _defineProperty from "/app/workspaces/v_1/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Block } from '../../abstract/Block.js';
export class Select extends Block {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init$", {
      ...this.init$,
      currentText: '',
      options: [],
      selectHtml: '',
      onSelect: e => {
        var _this$$$options$find;
        e.preventDefault();
        e.stopPropagation();
        this.value = this.ref.select.value;
        this.$.currentText = ((_this$$$options$find = this.$.options.find(opt => {
          return opt.value == this.value;
        })) === null || _this$$$options$find === void 0 ? void 0 : _this$$$options$find.text) || '';
        this.dispatchEvent(new Event('change'));
      }
    });
  }
  initCallback() {
    super.initCallback();
    this.sub('options', ( /** @type {{ text: String; value: String }[]} */options) => {
      var _options$;
      this.$.currentText = (options === null || options === void 0 || (_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.text) || '';
      let html = '';
      options === null || options === void 0 || options.forEach(opt => {
        html += /* HTML */"<option value=\"".concat(opt.value, "\">").concat(opt.text, "</option>");
      });
      this.$.selectHtml = html;
    });
  }
}
Select.template = /* HTML */"\n  <button>\n    {{currentText}}\n    <lr-icon name=\"select\"></lr-icon>\n    <select ref=\"select\" set=\"innerHTML: selectHtml; onchange: onSelect\"></select>\n  </button>\n";